module.exports = __webpack_public_path__ + "media/images/icon__settings@3x-1d7d94a8ce1f9635212b6fe429604f1c.png";